export const ERROR_CODES = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  VALIDATION_ERROR: 422,
  TOO_MANY_REQUESTS: 429,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  NOT_ALLOWED: 405
} as const;
